import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStackOverflow } from '@fortawesome/free-brands-svg-icons'
import Typed from 'react-typed';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Avatar, Typography, IconButton } from '@material-ui/core';
import avater from '../../images/avatar.jpg'
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';
import { Link } from 'react-router-dom';
import myresume from '../../Data/ResumeOfMd_Asikur_Rahaman.pdf'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';



// CSS Style
const useStyles = makeStyles((theme) => ({
    avatar: {
        height: theme.spacing(25),
        width: theme.spacing(25),
        margin: theme.spacing(1),
        [theme.breakpoints.down("xs")]: {
            height: theme.spacing(15),
            width: theme.spacing(15),
            margin: theme.spacing(1),
        }
    },
    bodyContainer: {
        // position: 'absolute',
        // top: '50%',
        // left: '50%',
        // transform: 'translate(-50%, -50%)',
        // zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'

    },
    title: {
        color: 'tomato',
        [theme.breakpoints.down("xs")]: {
            fontSize: '1.5rem',
        }
    },
    subtitle: {
        color: '#fff'
    },
    iconColor: {
        color: 'tomato',
        fontSize: '2rem'
    },
    description: {
        color: '#fff',
        maxWidth: '50%',
        [theme.breakpoints.down("sm")]: {
            maxWidth: '90%',
        }
    },
    iconstyle: {
        display: 'flex',
        zIndex:1000
    }


}));

const HomeBody = () => {
    const classes = useStyles();
    return (
        <Box className={classes.bodyContainer}>


            <Avatar className={classes.avatar} src={avater} alt="Md Asikur Rahaman" />
            <Typography className={classes.title} variant="h4">
                Hi.. I am <br /> Md Asikur Rahaman
            </Typography>
            <Typography className={classes.subtitle} variant="h5">
                <Typed
                    strings={[
                        'Front-end Developer',
                        'React Js Developer',
                        'JavaScript Developer'
                    ]}
                    typeSpeed={70}
                    backSpeed={80}
                    loop
                >
                </Typed>
            </Typography>
            <Typography variant="body1" className={classes.description}>
                I am an Experienced Front-End( React Js) web Developer with a demonstrated history of working in the Local Marketplace. Skilled in web design and Front-End Development using Modern JavaScript library like React Js, hooks, Redux. Strong engineering professional with a Computer Science and Engineer. For more details and projects see my profile and portfolio link.
            </Typography>
            <Box className={classes.iconstyle}>
                <IconButton edge="start" aria-label="menu">
                    <a target="_blan" href="https://github.com/asikurr"><GitHubIcon className={classes.iconColor} /></a>
                </IconButton>
                <IconButton edge="start" aria-label="menu">
                    <a target="_blan" href="https://www.linkedin.com/in/asikur-cse/"><LinkedInIcon className={classes.iconColor} /></a>
                </IconButton>
                <IconButton edge="start" aria-label="menu">
                    <a target="_blan" href="https://www.facebook.com/asikur.cse"><FacebookIcon className={classes.iconColor} /></a>
                </IconButton>
                <IconButton edge="start" aria-label="menu">
                    <a target="_blan" href="https://stackoverflow.com/users/13956406/asikur-rahaman"><FontAwesomeIcon icon={faStackOverflow} className={classes.iconColor} /></a>
                </IconButton>
                <IconButton edge="start" aria-label="menu">
                    <Link to={`${myresume}`} target="_blank" download><CloudDownloadIcon className={classes.iconColor} /></Link>
                </IconButton>
                
            </Box>
        </Box>
    );
};

export default HomeBody;